import { apiGetCompanies } from 'app/api_v2/companies';
import ErrorsList from 'app/ui_v2/components/errors-list/ErrorsList';
import BasicAutocomplete from 'app/ui_v2/form-fields/basic-fields/autocomplete/BasicAutocomplete';
import { useEffect, useState } from 'react';

import { useQuery } from '@tanstack/react-query';

export interface AgencyPickerProps {
  control: any;
  fieldName: string;
  fieldLabel: string;
}

export default function AgencyPicker(props: AgencyPickerProps) {
  const { control, fieldName, fieldLabel } = props;

  const { isLoading, isSuccess, isError, error, data } = useQuery({
    queryKey: ['bo-agencies-list'],
    queryFn: ({ signal }) => apiGetCompanies({ limit: 5000 }, signal),
    keepPreviousData: true,
  });

  const [collection, setCollection] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    if (data) {
      const coll = data.results.map((item) => ({
        id: item.id,
        name: item.name,
      }));

      setCollection(coll);
    }
  }, [data, isSuccess]);

  return (
    <>
      <BasicAutocomplete
        collection={collection}
        label={fieldLabel}
        inputName={fieldName}
        control={control}
        isLoading={isLoading}
        placeholder={'Pick agency'}
        disabled={isLoading}
      />
      {isError && error && <ErrorsList title="Unexpected loading error" errors={error as string[]} />}
    </>
  );
}
